import React from "react";
import { connect } from "react-redux";
import MDReactComponent from "markdown-react-js";
import { activateOverlayAction } from "../../../../services/ui/overlay/actions";

import {
  HEADER_COPY,
  BODY_COPY,
  CTA_COPY
} from "../../../../utils/content-keys";
import "./sign-up.scss";
import tracking from "../../../../utils/tracking";

class SignUp extends React.Component {
  componentDidMount() {
    if (window.location.hash === "#signUp" && !this.props.triggered) {
      this.props.activateOverlayAction(this.props.overlayId);
    }
  }

  onClick = () => {
    const { activateOverlayAction, overlayId, routeProps } = this.props;
    tracking.event("customEvent", {
      eventCategory: "Sign Up",
      eventAction: "click",
      eventLabel: routeProps.location.pathname
    });

    tracking.pageView("/newsletter-subscribe");
    tracking.event("formShown", { formName: "newsletter-subscribe" });
    activateOverlayAction(overlayId);
  };

  render() {
    const { content } = this.props;

    return (
      <aside className="sign-up container-fluid">
        <div className="sign-up__content-wrapper row no-gutters">
          <div className="sign-up__col-1 col-12 col-md-9">
            <h2 className="sign-up__title">{content[HEADER_COPY].value}</h2>
            <p className="sign-up__copy">
              <MDReactComponent text={content[BODY_COPY].value} />
            </p>
          </div>

          <div className="sign-up__col-2 col-12 col-md-3">
            <button
              className="sign-up__cta cta cta--lg-font"
              onClick={this.onClick}
            >
              {content[CTA_COPY].value}
              {/* {content.cta} */}
            </button>
          </div>
        </div>
      </aside>
    );
  }
}

export default connect(
  state => ({ triggered: state.overlay.triggered }),
  { activateOverlayAction }
)(SignUp);



// WEBPACK FOOTER //
// ./src/components/_common/Newsletter/SignUp/index.js